import structuredClone from '@ungap/structured-clone';

import { NodeMap, Tree, TreeMap } from '../pages/mindmap/types';

/**
 * Converts a flat node map with parent references into a hierarchical tree.
 * @param nodeMap A map with id's as keys and nodes as values.
 * @param isRootNode A function that checks if a node is the root node. Useful for selecting subtrees.
 * @returns A tree or undefined
 */
export const nodemapToTree = (nodeMap: NodeMap, isRootNode = (node: Tree) => !node.pid): Tree | undefined => {
  let tree: Tree | undefined;
  // deep clone flat node map to prevent making changes to it
  let treeMap: TreeMap = structuredClone(nodeMap) as TreeMap;

  Object.values(treeMap).forEach(flatNode => {
    if (isRootNode(flatNode)) {
      tree = treeMap[flatNode.id];
    } else if (flatNode.pid) {
      // check if node's parent exists
      if (treeMap[flatNode.pid]) {
        // create children array in node's parent if needed
        if (!treeMap[flatNode.pid].children) treeMap[flatNode.pid].children = [];
        // add node to node's parent's children
        let children;
        if ((children = treeMap[flatNode.pid].children)) {
          children.push(treeMap[flatNode.id]);
        }
      }
    }
  });

  return tree;
};
